import React, { Fragment, useState } from 'react'
import { connect, useDispatch } from 'react-redux'
import { NavLink } from 'react-router-dom'
import styled from 'styled-components'
import { setUpdatedCart } from '../../../redux/auth-reducer'
import { setModal } from '../../../redux/modals-reducer'
import Empty from '../../Empty'

const Wrapper = styled.div`
	background: #ffffff;
	position: absolute;
	right: 0;
	top: 0;
	height: 100%;
	width: 508px;
	display: flex;
	flex-direction: column;
`
const Head = styled.div`
	height: 73px;
	padding: 10px 20px;
	display: flex;
	align-items: center;
	justify-content: space-between;
	.right {
		display: flex;
		align-items: center;
	}
	h3 {
		font-size: 24px;
		color: #1b1b1b;
		font-weight: 500;
	}
	span {
		background: #f3f4f5;
		text-transform: uppercase;
		color: #1b1b1bb3;
		border-radius: 4px;
		margin-right: 9px;
		padding: 6px;
		font-size: 10px;
		font-weight: 500;
	}
	svg {
		cursor: pointer;
	}
`

const List = styled.div`
	max-height: 100%;
	overflow: hidden;
	overflow-y: scroll;
	padding: 28px 20px 0;
	display: flex;
	flex-direction: column;
`

const Card = styled.div`
	display: flex;
	align-items: center;
	&:nth-child(n + 2) {
		margin-top: 20px;
	}
	h3 {
		font-size: 16px;
		color: #1b1b1b;
		font-weight: 500;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 100%;
		white-space: nowrap;
	}
	p {
		font-size: 16px;
		color: #1b1b1bbb;
		font-weight: 400;
		overflow: hidden;
		text-overflow: ellipsis;
		max-width: 100%;
		white-space: nowrap;
	}
	.left {
		width: 120px;
		margin-right: 24px;
	}
	.column {
		max-width: 60%;
	}
	img {
		border-top-right-radius: 5px;
		border-top-left-radius: 5px;
		width: 100%;
		height: 115px;
	}
`

const Counter = styled.div`
	height: 33px;
	background: #f3f4f5;
	display: grid;
	grid-template-columns: repeat(3, 33px);
	align-items: center;
	justify-content: space-between;
	border-bottom-right-radius: 5px;
	border-bottom-left-radius: 5px;
	span {
		display: flex;
		align-items: center;
		justify-content: center;
		cursor: pointer;
	}
	div {
		display: flex;
		align-items: center;
		justify-content: center;
		font-size: 14px;
		font-weight: 400;
	}
`

const InfoText = styled.p`
	margin-top: auto;
	padding: 20px;
	margin-bottom: 14px;
	color: #747474;
	font-size: 14px;
	a {
		text-decoration: underline;
		font-size: 1em;
		color: #747474;
	}
`

const Subtotal = styled.div`
	padding: 20px;
	border-top: solid 1px rgba(193, 193, 193, 0.3);
	display: flex;
	align-items: center;
	justify-content: space-between;
	.column {
		display: flex;
		flex-direction: column;
	}
	h3 {
		color: #1b1b1b;
		font-size: 14px;
		margin-bottom: 4px;
		font-weight: 500;
	}
	p {
		font-weight: 400;
		color: #1b1b1b;
		font-size: 14px;
	}
	button {
		height: 55px;
		color: #fff;
		font-weight: 600;
		width: 180px;
		background: #000;
		border-radius: 5px;
		transition: 0.2s all ease;
	}
`

const Delete = styled.div``

const CartList = ({ list, dispatch }) => {
	const [search, setSearch] = useState('')

	const addOrDeleteItem = (product, action) => {
		dispatch(
			setUpdatedCart(
				{
					id: product.id,
				},
				action
			)
		)
	}

	return (
		<Fragment>
			{list
				.filter((el) =>
					search.length
						? el.name.toLowerCase().includes(search.toLowerCase())
						: true
				)
				.map((i) => (
					<Card>
						<div className="left">
							<img src={i.image} alt="" />
							<Counter>
								<span onClick={() => addOrDeleteItem(i, 'delete')}>
									<svg
										width="10"
										height="2"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M1 1h8"
											stroke="currentColor"
											stroke-linecap="square"
										></path>
									</svg>
								</span>
								<div>{i.count}</div>
								<span onClick={() => addOrDeleteItem(i, 'add')}>
									<svg
										width="11"
										height="11"
										fill="none"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											d="M5.5 0v11M0 5.5h11"
											stroke="currentColor"
										></path>
									</svg>
								</span>
							</Counter>
						</div>
						<div className="column">
							<h3>
								{i.name}
							</h3>
							<p>${i.price * i.count}</p>
						</div>
					</Card>
				))}
		</Fragment>
	)
}

const Cart = (props) => {
	let dispatch = useDispatch()

	return (
		<Wrapper>
			<Head>
				<h3>Ваша корзина</h3>
				<div className="right">
					<span>USD</span>
					<svg
						onClick={() => dispatch(setModal(null))}
						width="17"
						height="16"
						viewBox="0 0 17 16"
						fill="none"
						xmlns="http://www.w3.org/2000/svg"
					>
						<path
							d="M15.0636 15.7682L8.48445 9.18909L1.90512 15.7682L0.982808 14.8459L7.56214 8.26678L0.952276 1.65692L1.90533 0.703866L8.51519 7.31373L15.125 0.703864L16.0473 1.62617L9.4375 8.23604L16.0166 14.8152L15.0636 15.7682Z"
							fill="black"
						></path>
					</svg>
				</div>
			</Head>
			<List>
				{props.cart.length ? (
					<CartList list={props.cart} dispatch={props.dispatch} />
				) : (
					<Empty />
				)}
			</List>
			<InfoText>
				<p>
					The total charges for this order do not include any import
					taxes or customs duties. <a href="/">Read more</a>
				</p>
			</InfoText>
			<Subtotal>
				<div className="column">
					<h3>Your subtotal today is ${
                        props.cart.reduce((partial_sum, a) => partial_sum + (a.count * a.price), 0)
                    }.</h3>
					<p>Tax included. Free shipping.</p>
				</div>
				<NavLink to="/checkout">
					<button>Checkout</button>
				</NavLink>
			</Subtotal>
		</Wrapper>
	)
}

let mapStateToProps = (state) => {
	return {
		cart: state.auth.cart,
	}
}

export default connect(mapStateToProps, null)(Cart)
